import styles from "./index.module.scss";
const NoData = () => {
	return <div className={styles.nodataBox}>
		<img src={`${process.env.PUBLIC_URL}/svg/nodata.svg`} />
		<div>It's empty in here...</div>
	</div>
}
export default NoData;